import {
  ApplicationConfig,
  ErrorHandler,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { environment } from '../environments/environment';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { DataService } from './services/data.service';
import { GlobalErrorHandlerService } from './services/global-error-handler.service';
import { manageSpinnerStateInterceptor } from './http-interceptors/manage-spinner-state-interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    DataService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },

    provideRouter(routes),
    provideHttpClient(withInterceptors([manageSpinnerStateInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: 'false',
        },
      },
    }),
  ],
};
